import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Currency')
export class Currency {
  @JsonProperty('code', String, true) code: string = undefined;
  @JsonProperty('symbol', String, true) symbol: string = undefined;
}
